import { getForwardData } from 'portal-common-account/src/api/login';
import syncCookie from 'portal-common-account/src/utils/syncCookie';

import { windowOpen } from '../../utils';

export default async function loginForward(loginSuccessCall, setCurRoute, params) {
  await forward(loginSuccessCall, setCurRoute, params);
}

async function forward(loginSuccessCall, setCurRoute, params, isLoop) {
  try {
    const { data } = await getForwardData(params || {});
    const { redirectUrl, needVerify = false, needMFA = false, needResetPwd = false, sub_token, ownerUin } = data;
    if (needVerify) {
      return setCurRoute('VerifyBox');
    }
    if (needMFA) {
      timeOut(() => forward(loginSuccessCall, setCurRoute, params, true));
      return !isLoop && windowOpen(redirectUrl);
    }

    if (needResetPwd) {
      return setCurRoute({
        path: 'SubAccount',
        payload: {
          token: sub_token,
          ownerUin,
        },
      });
    }

    await syncCookie({ token: sub_token });

    if (/.com$/.test(redirectUrl) && !/s_url/.test(redirectUrl)) {
      return loginSuccessCall();
    }
    if (redirectUrl) {
      windowOpen(redirectUrl);
    }
    return loginSuccessCall();
  } catch (err) {
    setCurRoute('LoginForm');
  }
}

const timeOut = (callback, timer) => {
  const time = setTimeout(() => {
    callback && callback();
    clearTimeout(time);
  }, timer || 2000);
};
